import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import { Link } from 'react-router-dom';


const ListaMasajistas = () => {
    const { user } = useAuth();
    const [masajistas, setMasajistas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        const fetchMasajistas = async () => {
            try {
                const res = await api.get('/appointments/masajistas');
                setMasajistas(res.data);
            } catch (err) {
                setError('Error al cargar los masajistas');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchMasajistas();
    }, []);

    if (loading) return <div className="loading-spinner">Cargando...</div>;
    if (error) return <div className="alert alert-danger">{error}</div>;

    return (
        <div className="lista-masajistas">
            <h2>🧘 Nuestros Profesionales</h2>
            <div className="masajistas-grid">
                {masajistas.map(m => (
                    <div key={m._id} className="masajista-card">
                        <div className="masajista-avatar">
                            {m.nombre?.charAt(0)}{m.apellido?.charAt(0)}
                        </div>
                        <div className="masajista-info">
                            <h4>{m.nombre} {m.apellido}</h4>
                            <p>📧 {m.email}</p>
                            <p>📱 {m.telefono || 'Sin teléfono'}</p>
                        </div>
                        <Link to={`/paciente/reservar/${m._id}`} className="btn-reservar">
                            Ver disponibilidad
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ListaMasajistas;